import { useRouter } from '@tanstack/react-router';

const LOGIN_PAGE = '/login';
const AUTH_REQUIRED_PAGE = '/auth/required';
const SESSION_END_PAGE = '/auth/end';

export function isBlacklistedUrl(url: string) {
  const isBlacklisted = !![LOGIN_PAGE, AUTH_REQUIRED_PAGE, SESSION_END_PAGE].find((p) =>
    url.startsWith(p),
  );

  return isBlacklisted;
}

export function redirectSanitized(router: ReturnType<typeof useRouter>, back: string = '/') {
  router.navigate({
    from: '/',
    to: sanitizeUrl(back),
  });
}

export function createLoginLink(to: string = '/') {
  return `https://id.chessopen.ru/?source=PlayChessOpen&back=${sanitizeUrl(to)}`;
}

function sanitizeUrl(url: string = '/') {
  return isBlacklistedUrl(url) || url.includes('@') ? '/' : url;
}
